export default "__VITE_ASSET__D1TjzC3S__"